import { pageQuery } from '~/queries/page'
import { articleQuery } from '~/queries/article'
import pageEntryQueries from '~/queries/pages'

const sectionEntryTypes = {
    'ds_Events': ['ds_Events_Entry'],
    'ds_News': ['ds_News_Entry'],
    'ds_Newsletters': ['ds_Newsletter_Entry'],
    'ds_NewsletterArticles': ['ds_NewsletterArticle_Entry'],
    'ds_Pages': ['ds_StandardPage_Entry', 'ds_RedirectPage_Entry'],
    'ds_Homepage': ['ds_Homepage_Entry'],
    'ds_Microsites': ['ds_MicrositeHomepage_Entry','ds_MicrositePage_Entry'],
}

export const useEntryStore = defineStore('entryStore', {
    state: () => ({
        entry: {},

        seomatic: {},
        variables: {},
    }),
    actions: {
        getPageQuery(isArticle = false) {
            const { digistormSettings } = useGlobalStore()

            let builtQuery = pageQuery
            if (isArticle) {
                builtQuery = articleQuery
            }

            let pageQueryHelper = ''

            // add possible sections to query
            const enabledSections = get(digistormSettings, 'enabledSections', [])

            each(enabledSections, (section) => {
                const sectionTypes = get(sectionEntryTypes, section)

                each(sectionTypes, (entryType) => {
                    builtQuery += get(pageEntryQueries, entryType, '')
                    pageQueryHelper += `
                        ... on ${entryType} {
                            ...${entryType}
                        }
                    `
                })
            })

            return replace(builtQuery, '[entryQuery]', pageQueryHelper)
        },

        async loadEntry(uri, slug) {
            const { query } = useGraphQL()

            let variables = {
                uri,
                retourUri: `/${uri}`
            }

            // only support newsletter articles for now
            if (!isEmpty(slug)) {
                variables = {
                    slug,
                    type: 'ds_NewsletterArticle'
                }
            }

            const pageData = await query({
                query: this.getPageQuery(!!slug),
                key: `entry-${uri}`,
                variables,
            })

            const redirect = get(pageData, 'retourResolveRedirect', {})

            if (redirect && !isEmpty(redirect.redirectDestUrl) && redirect.enabled) {
                const route = useRoute()
                return navigateTo({
                    path: redirect.redirectDestUrl,
                    query: route.query
                }, {
                    redirectCode: redirect.redirectHttpCode || 301,
                    replace: true,
                    external: true
                })
            }

            // replace page data entry
            this.entry = get(pageData, 'entry', {})

            if (isEmpty(this.entry?.slug)) {
                throw createError({
                    statusMessage: 'Page not found',
                    message: 'The page you are looking for does not exist. <br /><br />Try finding what you are looking for by searching from the top menu or return back to the homepage',
                    statusCode: 404,
                })
            }

            // Handle RedirectPage entries
            if (this.entry?.__typename === 'ds_RedirectPage_Entry') {
                const redirectUrl = this.entry?.redirectLink?.[0].linkUrl

                if (redirectUrl) {
                    return navigateTo({
                        path: redirectUrl,
                        query: useRoute().query
                    }, {
                        redirectCode: 301,
                        replace: true,
                        external: true
                    })
                }
            }

            this.initEntry()
        },


        initEntry() {
            const micrositeStore = useMicrositeStore()

            this.seomatic = get(this.entry, 'seomatic', {})
            this.variables = JSON.parse(get(this.seomatic, 'metaSiteVarsContainer', '{}'))

            // check if microsite
            if(['ds_MicrositeHomepage_Entry', 'ds_MicrositePage_Entry'].includes(this.entry.__typename)) {
                micrositeStore.initMicrosite(this.entry)
            }
        },


    },
})
